/**
 * Idle-session timeout bounds (#181). Mirrors
 * infrastructure/lambda/shared/session-timeout-limits.ts — kept in sync by hand
 * since the frontend and Lambda packages don't share a build step.
 */
export const MIN_SESSION_TIMEOUT_MINUTES = 1
export const MAX_SESSION_TIMEOUT_MINUTES = 1440
